import { render, staticRenderFns } from "./shift-close.vue?vue&type=template&id=247d29d5&scoped=true"
import script from "./shift-close.vue?vue&type=script&lang=js"
export * from "./shift-close.vue?vue&type=script&lang=js"
import style0 from "./shift-close.vue?vue&type=style&index=0&id=247d29d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247d29d5",
  null
  
)

export default component.exports